import {BASE_URL} from '../config'
import axios from '../utils/axios';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { fetch } from '@app/apiFunction';




export const getAllClientNames = async () => {
  const token = localStorage.getItem('token');
  const type="get"
  const url = BASE_URL+'/client/all-client-name'
  const resp = await fetch(url, type, null, token)
  return resp;
};

export const createClient = async (payloadGet) => {

    const payload = JSON.stringify(payloadGet);
    const token = localStorage.getItem('token');
    const url = BASE_URL+'/client/create'
    const type = "post"
    const resp = fetch(url, type, payload, token)
   return resp;
 
  };

  export const updateClient = async (payloadget) => {
    const clientId = localStorage.getItem("clientId")
    const payload = JSON.stringify(payloadget);
    const url = BASE_URL+'/client/update/' + clientId
    const token = localStorage.getItem('token');
    const type ="post"
    const resp = fetch(url, type, payload, token)
   return resp;
 
  };

  export const getAllClient = async (query) => {
    let requestQuery=""
    if(query)
    {
  
      for (const [key, value] of Object.entries(query)) {
        requestQuery=`${key}=${value}`;
    }
  }
    const token = localStorage.getItem('token');
    const type = "get"
    const url =  BASE_URL+'/client/get-all-client?'+requestQuery
    const resp = fetch(url, type, null, token)
    return resp;
  };


  export const getClientById = async () => {
    const token = localStorage.getItem('token');
    const clientId = localStorage.getItem('clientId')
    const type ="get"
    const url = BASE_URL+'/client/'+ clientId
    const resp = fetch(url, type, null, token)
    return resp;
  };
